import { Injectable } from "@angular/core";
import { Sample } from "../base/Sample";
import { STATUS_CONST } from "../base/Status";
import { User } from "../base/User";

@Injectable({
    providedIn: "root"
})
export class PermissionsService {

    savePermissionToLocalStorage(permission: any): void {
        localStorage.setItem('permission', permission);
    }

    getPermissionFromLocalStorage(): any {
        const permission = localStorage.getItem('permission');
        return permission ? JSON.parse(permission) : null;
    }

    //ROUTING PERMISSION
    canViewSampleEdit(user: User, sample: Sample): boolean {
        let ans: boolean = false;
        if (user.Permission.admin||user.Permission.labTechnician||user.Permission.labManager) {
            ans = true;
        } else if (user.Permission.customer && (this.isUserCreatedGivenSample(user, sample))) {
            ans = true;
        }
        if (ans) this.savePermissionToLocalStorage('labTechnician');
        return ans;
    }

    canViewSampleCreate(user: User): boolean {
        const canView = user.Permission.admin || user.Permission.customer;
        if (canView) {
            this.savePermissionToLocalStorage('customer');
        }
        return canView;
    }

    canViewLabArea(user: User): boolean {
        const canView = user.Permission.labManager || user.Permission.labTechnician;
        if (canView) this.savePermissionToLocalStorage('labManager');
        return canView;
    }

    canViewAdminArea(user: User): boolean {
        const canView = user.Permission.admin;
        if (canView) this.savePermissionToLocalStorage('admin');
        return canView;
    }
    canViewWorkerLabArea(user: User): boolean {
        return true;
    }

    canViewSampleEditAsLab(user: User, sample: Sample): boolean {
        let ans: boolean = false;
        //ONLY IF THIS SAMPLE
        if (sample.status !== STATUS_CONST.STATUS_CREATED) {
            if (user.Permission.labManager || user.Permission.labTechnician) {
                ans = true;
            }
        }
        if (ans) this.savePermissionToLocalStorage('labTechnician');
        return ans;
    }

    //EDITING PERMISSIONS
    canEdit(user: User, sample: Sample, input?: string): boolean {
        let ans = false;
        if (!input && this.isUserCreatedGivenSample(user, sample)) {
            ans = true;
        } else if ((user.Permission.admin && input && LIST_ADMIN_CAN_EDIT.includes(input))||(user.Permission.labTechnician&&sample.userId==user.id)) {
            ans = true;
        }
        else if (this.canViewLabArea(user) && input && LIST_LAB_CAN_EDIT.includes(input)) {
            ans = true;
        }
        // else if ( LIST_LAB_CAN_EDIT.includes(input)) {
        //     ans = true;
        // }
        if (ans) this.savePermissionToLocalStorage('labTechnician');
        return ans;
    }

    isLabManager(user: User): boolean {
        const isManager = user.Permission.labManager;
        if (isManager) this.savePermissionToLocalStorage('labManager');
        return isManager;
    }

    isAdmin(user: User): boolean {
        const isAdminUser = user.Permission.admin;
        if (isAdminUser) this.savePermissionToLocalStorage('admin');
        return isAdminUser;
    }

    isLabTec(user: User): boolean {
        const isTec = user.Permission.labTechnician;
        if (isTec) this.savePermissionToLocalStorage('labTechnician');
        return isTec;
    }
    isCustomer(user: User): boolean {
        const isCustomerUser = user.Permission.customer;
        if (isCustomerUser) this.savePermissionToLocalStorage('customer');
        return isCustomerUser;
    }

    isGuest(user: User): boolean {
        let ans: boolean = false;
        if (!this.isAdmin(user) && !this.canViewLabArea(user) && !this.isCustomer(user)) {
            ans = true;
        }
        return ans;
    }

    public isUserInGuestList(user: User, sample: Sample): boolean {
        return sample.emailsString.indexOf(user.email) !== -1;
    }

    //HELPERS
    private isUserCreatedGivenSample(user: User, sample: Sample): boolean {
        return user.id === sample.userId;
    }

   
}

export const LIST_ADMIN_CAN_EDIT = [
    'emails'
]

export const LIST_LAB_CAN_EDIT = [
    'status',
    'comments',
    'results',
    'dangersSection',

]

